<template>
  <div class="comercializadora-grid-container">
    <div class="comercializadora-container">
      <div class="comercializadora-logo-container">
        <img v-if="model?.ImagenB64 != ''" :src="model?.ImagenB64!" class="comercializadora-logo" />
      </div>
    </div>

    <div class="comercializadora-info">
      <div>
        <h5>
          {{ model?.RazonSocial }}
        </h5>
      </div>
      <div>
        {{ model?.Direccion?.DireccionCompleta }}
      </div>
      <div>
        <!-- {{ model?.NombreContacto }} -->
      </div>
    </div>

    <div class="comercializadora-contact">
      <div>
        {{ model?.Email }}
      </div>
      <div>
        {{ model?.Telefono }}
      </div>
    </div>
  </div>

</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { type DetailEmpresaInmobiliariaModel } from '@api/api';
import { useApi } from '@api/integration';

const props = defineProps({
  idEmpresaInmobiliaria: String
});

const model = ref<DetailEmpresaInmobiliariaModel>();
const api = useApi();

onMounted(async () => {
  var empresaInmobiliariaDetail = await api.callStandardApi("getEmpresaInmobiliariaById", { showLoading: false }, props.idEmpresaInmobiliaria!);
  model.value = empresaInmobiliariaDetail;
});
</script>


<style lang="scss" scoped>


.comercializadora-grid-container {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  gap: 20px;
  align-items: center;
  box-sizing: border-box;
  max-width: 50%;
  margin-bottom: 15px;
}

.comercializadora-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.comercializadora-logo-container {
  border: 1px solid var(--border-default-default);
  background-color: var(--background-surface-default);
  min-height: 90px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 5px;
  max-height: 100px;
}

.comercializadora-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.comercializadora-info,
.comercializadora-contact {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 5px;
}

.comercializadora-contact {
  border-left: 2px solid var(--border-default-default);
  padding-left: 20px;
}
</style>